<ng-container *ngIf="timeSpans?.length > 0">
  <app-horizontal-timeline [items]="timeSpans" [marker]="markerData" class="horizontal-timeline">
  </app-horizontal-timeline>
</ng-container>

<ng-container *ngIf="!timeSpans || timeSpans?.length == 0">
  <div class="no-data-text"> Missing status
  </div>
</ng-container>
